import React, { PropTypes } from "react";
import { FormattedMessage } from "react-intl";

import { Field } from "redux-form";
import { CLIENTS_VALIDATION_RULES } from "../../clientValidationRules";
import { TextInput } from "../../../../common/form";

const ClientAcomba = ({disabled}) => (
  <div className="ClientSubsection">
    <h3>
      <FormattedMessage id="clients.form.acombaSettings.title" />
    </h3>
    <Field
      id="acombaProjectNumber"
      name="acombaProjectNumber"
      type="text"
      disabled = {disabled}
      maxLength={CLIENTS_VALIDATION_RULES.acombaProjectNumber.maxLength.value}
      component={TextInput}
      label={
        <FormattedMessage id="clients.form.acombaSettings.acombaProjectNumber" />
      }
    />
    <Field
      id="acombaNumber"
      name="acombaNumber"
      type="number"
      disabled = {disabled}
      maxLength={CLIENTS_VALIDATION_RULES.acombaNumber.maxLength.value}
      component={TextInput}
      label={<FormattedMessage id="clients.form.acombaSettings.acombaNumber" />}
    />
  </div>
);

ClientAcomba.propTypes = {
  disabled: PropTypes.bool,
};

export default ClientAcomba;



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client-form/basic-client-sections/ClientAcomba.js